export const defaultState = () => ({
  programmingTitle: "Programação de Abate",
  listaDatas: [],
  listDatesWithDemand: [],
  loading: false,
  listaSemana: [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado"
  ],
  isSlaughterScheduleSelected: false,
  programacaoAbateSelected: {
    idProgramacaoAbate: 0,
    cdStatusProgramacaoAbate: 0,
    dtInicioAbate: "",
    dtFimAbate: "",
    nrProgramacaoAbate: ""
  },
  listaDemandasPlanta: [],
  plantasAbate: [],
  municipios: [],
  demandSaved: false,
  itemsPerPageBatchsAvaliable: 40,
  pageBatchsAvaliable: 1,
  listBatchsAlreadyAllocated: [],
  listBathsAvaliable: [],
  listExtensionistas: [],
  listTiposGenero: [],
  listaProgramacoesPlanta: [],
  cities: [],
  availableLots: {},
  availableLotsMeta: {},
  availableLotsCurrPage: {},
  slaughterPlantEstablishments: [],
  listBatchsAllocated: [],
  listBatchsAllocatedToRemove: [],
  listCheckListAlocados: [],
  dialogBathsAvaliable: false,
  canEditDemands: false,
  
  isCutting: false,
  isCopying: false,
  
  idProgramacaoAbateAlocadoToCopy: null
});

const state = defaultState();

export default state;
